import { SaneBlockChakra } from '@components';
import { singlePageProps } from '@lib/singlePageProps';

export default function PrivacyPage({ text, body }: any) {
  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <p className="mb-2 text-base font-semibold text-center text-clerk-blue">
        LEGAL
      </p>
      <h1 className="text-4xl font-bold text-center ">{text.heroTitle}</h1>
      <div className="mx-auto mt-6 prose prose-lg text-gray-500 prose-clerk-blue">
        {body.map(({ key, richText }: any) => (
          <SaneBlockChakra key={key} blocks={richText} />
        ))}
      </div>
    </div>
  );
}

const slug = '/privacy';
export async function getStaticProps({ preview = false }) {
  return singlePageProps({ preview, slug });
}
